<div [ngClass]="[containerClass, 'drag-drop-container']">
  <h2>{{leftTitle}}</h2>

  <div
    cdkDropList
    #leftListElement="cdkDropList"
    [cdkDropListData]="leftList"
    [cdkDropListConnectedTo]="[rightListElement]"
    [ngClass]="[listClass, 'drag-drop-list']"
    (cdkDropListDropped)="drop($event)">
    <div class="drag-drop-box" *ngFor="let item of leftList" cdkDrag [cdkDragPreviewContainer] = "parentContainer">
    	{{labelGetter.call(null, item)}}
    </div>
  </div>
</div>

<div [ngClass]="[containerClass, 'drag-drop-container']">
  <h2>{{rightTitle}}</h2>

  <div
    cdkDropList
    #rightListElement="cdkDropList"
    [cdkDropListData]="rightList"
    [cdkDropListConnectedTo]="[leftListElement]"
    [ngClass]="[listClass, 'drag-drop-list']"
    (cdkDropListDropped)="drop($event)">
    <div class="drag-drop-box" *ngFor="let item of rightList" cdkDrag [cdkDragPreviewContainer] = "parentContainer">
    	{{labelGetter.call(null, item)}}
    </div>
  </div>
</div>